module.exports = __webpack_public_path__ + "static/media/mathwallet.fb35b33c.svg";